import { PushNotifications } from "@capacitor/push-notifications";
import { Badge } from '@capawesome/capacitor-badge';
import { Session } from "@restofrit/networking";

/**
 * Marks all notifications as seen on the server. This resets the baseline for
 * the OS app-icon badge sent in push payloads, without touching the in-app
 * read/unread state that drives the bell badge and the notification center.
 * Call on app-foreground.
 */
export async function markNotificationsSeen(customerId: string) {
    try {
        await Session.shared.authenticatedServer.request({
            method: "POST",
            path: "/customers/" + customerId + "/notifications/seen"
        })
    } catch (e) {
        console.error("Failed to mark notifications seen", e)
    }
}

/**
 * Marks all notifications as read on the server (which implies seen).
 * Call when the customer opens the notification center.
 */
export async function markNotificationsRead(customerId: string) {
    try {
        await Session.shared.authenticatedServer.request({
            method: "POST",
            path: "/customers/" + customerId + "/notifications/read"
        })
    } catch (e) {
        console.error("Failed to mark notifications read", e)
    }
}

/**
 * Clears the OS app-icon badge and removes delivered notifications from the tray.
 */
export async function clearOSBadge() {
    try {
        await Badge.clear()
    } catch (e) {
        console.warn("Badge.clear failed", e)
    }
    try {
        await PushNotifications.removeAllDeliveredNotifications()
    } catch (e) {
        console.warn("removeAllDeliveredNotifications failed", e)
    }
}
